import {trackSortChannel as updateCurrentPageSortChannel} from '@aboutyou/legacy-tracking-sdk';

export const useUpdateSortingChannel = (sortingChannel?: string) => {
  if (!process.browser || !window.clientState) {
    return;
  }

  if (!sortingChannel) {
    return;
  }

  updateCurrentPageSortChannel(window.clientState)({
    section: {
      sortChannel: sortingChannel,
      type: 'stream',
      sectionIndexOnPage: 0,
    },
  });
};
